import React from "react";

const QuotationViewToggleIcon = ({ type }) => {
  if (type === "project") {
    return (
      <svg
        className="quote-view-icon"
        viewBox="0 0 48 48"
        aria-hidden="true"
        focusable="false"
      >
        <path
          d="M6 13.5c0-3 2.4-5.5 5.5-5.5h10.8c1.3 0 2.5.5 3.4 1.4l4.1 4.1H38c3 0 5.5 2.4 5.5 5.5v17.5c0 3-2.4 5.5-5.5 5.5H11.5c-3 0-5.5-2.4-5.5-5.5v-23Z"
          fill="none"
          stroke="currentColor"
          strokeLinejoin="round"
          strokeWidth="3.3"
        />
        <path
          d="M7.5 19.5h33"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeWidth="3.3"
        />
        <rect x="16" y="25" width="6.8" height="6.8" rx="1.3" fill="currentColor" />
        <rect x="26.2" y="25" width="6.8" height="6.8" rx="1.3" fill="currentColor" />
        <rect x="16" y="34" width="6.8" height="6.8" rx="1.3" fill="currentColor" />
        <rect x="26.2" y="34" width="6.8" height="6.8" rx="1.3" fill="currentColor" />
      </svg>
    );
  }

  return (
    <svg
      className="quote-view-icon"
      viewBox="0 0 48 48"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M13 5.5h16.5L39.5 15.5V38c0 3-2.4 5.5-5.5 5.5H13c-3 0-5.5-2.4-5.5-5.5V11c0-3 2.4-5.5 5.5-5.5Z"
        fill="none"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="3.4"
      />
      <path
        d="M29.5 6v9.5H39"
        fill="none"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="3.4"
      />
      <path
        d="M16.5 24h15M16.5 31h15M16.5 38h15"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth="3.6"
      />
    </svg>
  );
};

export default React.memo(QuotationViewToggleIcon);
